import { Chain, createPublicClient, createWalletClient, http } from 'viem';
import { base, baseSepolia, mainnet, sepolia } from 'viem/chains';

function createBaseConfig(baseConfig: Chain): Chain {
  return {
    ...baseConfig,
    fees: {
      baseFeeMultiplier: 1.4,
    },
  };
}

const ethereumConfig = {
  chain: process.env.NEXT_PUBLIC_APP_ENV === 'production' ? mainnet : sepolia,
  urlName:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? 'eth-mainnet'
      : 'eth-sepolia',
};

const baseConfig = {
  chain:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? createBaseConfig(base)
      : createBaseConfig(baseSepolia),
  urlName:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? 'base-mainnet'
      : 'base-sepolia',
};

const ethereumAlchemyTransport = http(
  `https://${ethereumConfig.urlName}.g.alchemy.com/v2/${
    process.env.NEXT_PUBLIC_ALCHEMY_API_KEY as string
  }`,
);

const baseAlchemyTransport = http(
  `https://${baseConfig.urlName}.g.alchemy.com/v2/${
    process.env.NEXT_PUBLIC_ALCHEMY_API_KEY as string
  }`,
);

/**
 * @deprecated Use `EthereumAlchemyProvider` instead.
 */
export const AlchemyProvider = createPublicClient({
  chain: ethereumConfig.chain as Chain,
  transport: ethereumAlchemyTransport,
});

// Chain specific providers
export const EthereumAlchemyProvider = AlchemyProvider;

export const EthereumAlchemyWalletProvider = createWalletClient({
  chain: ethereumConfig.chain as Chain,
  transport: ethereumAlchemyTransport,
});

export const BaseAlchemyProvider = createPublicClient({
  chain: baseConfig.chain as Chain,
  transport: baseAlchemyTransport,
});

export const BaseAlchemyWalletProvider = createWalletClient({
  chain: baseConfig.chain as Chain,
  transport: baseAlchemyTransport,
});
